import type { PropsWithChildren } from 'react'
import styles from './SeccionNavegacion.module.css'

export function SeccionNavegacion({
  id,
  etiqueta,
  prominencia = 'secundaria',
  activa = false,
  mostrarEtiqueta = true,
  children,
}: PropsWithChildren<{
  id: string
  etiqueta: string
  prominencia?: 'principal' | 'secundaria'
  activa?: boolean
  mostrarEtiqueta?: boolean
}>) {
  const etiquetaId = `${id}-etiqueta`
  return (
    <section
      className={styles.section}
      data-prominence={prominencia}
      data-active={activa}
      aria-labelledby={mostrarEtiqueta ? etiquetaId : undefined}
      aria-label={mostrarEtiqueta ? undefined : etiqueta}
    >
      {mostrarEtiqueta ? <h2 id={etiquetaId} className={styles.sectionLabel}>{etiqueta}</h2> : null}
      <div className={styles.sectionBody} data-guided={mostrarEtiqueta}>{children}</div>
    </section>
  )
}
